import moment from 'moment'

/**
 * Converts the given time string (e.g. 14:00) into a moment object.
 * Also makes sure that minutes are either 00 or 30.
 * @param time
 * @param roundToSteps
 * @returns {moment.Moment}
 */
export const getMomentFromTime = (time: string, roundToSteps?: boolean) => {
  const parts: any = String(time).split(':')
  parts[0] = Number(parts[0])
  parts[1] = Number(parts[1])

  if (typeof roundToSteps === 'undefined') {
    roundToSteps = true
  }

  // Make sure that minutes are either 00 or 30
  if (roundToSteps) {
    if (parts[1] !== 0 && parts[1] !== 30) {
      parts[1] = parts[1] > 30 ? 30 : 0
    }
  }

  return moment().hours(parts[0]).minutes(parts[1]).seconds(0)
}
